import { ProductElement } from '@models/product';
import { formatDate } from '@angular/common';
import { Store } from '@models/store';

export class Order {
  _id: string;
  invoiceNumber: string;
  status?: string;
  type: string;
  restockOrder?: boolean;
  patient: string;
  notes?: string;
  part?: boolean;
  specialOrder?: boolean;
  warranty?: boolean;
  todo?: string;
  notify?: boolean;
  user?: string;
  eta?: string;
  date?: string;
  dateAdded?: string;
  dateUpdated?: string;
  archived?: boolean;
  images?: Object[];
  products?: ProductElement[];
  store?: string | Store;
  log?: LogElement[];
  vendorOrder?: string;
  shipping?: number;
  tax?: number;
  total?: number;
  framesRemoved?: string[];
  rxStatus?: string;
  jobAction?: string;
  frameOnly?: boolean;
  linkedInvoice?: string;
  frameOnlyTaxCredit?: number;
  frameOnlyTaxCreditUsed?: boolean;
  exchangeCredit?: number;
  returnCredit?: number;
  restockingFee?: number;
  restockingFeeWaived?: boolean;
  redoReason?: string;
  redoPriority?: boolean;
  redoPaidCredit?: number;
  fulfillment?: string;
  shippingAddress?: {
    address?: string;
    address2?: string;
    city?: string;
    state?: string;
    zip?: string;
  };

  constructor() {
    this._id = '';
    this.invoiceNumber = '';
    this.status = '';
    this.type = '';
    this.restockOrder = false;
    this.patient = null;
    this.notes = '';
    this.part = false;
    this.specialOrder = false;
    this.warranty = false;
    this.todo = '';
    this.notify = false;
    this.user = '';
    this.eta = '';
    this.date = '';
    this.dateAdded = '';
    this.dateUpdated = '';
    this.archived = false;
    this.images = [];
    this.products = [];
    this.store = null;
    this.log = [];
    this.vendorOrder = null;
    this.framesRemoved = [];
    this.rxStatus = '';
    this.jobAction = '';
    this.frameOnly = false;
    this.linkedInvoice = '';
    this.frameOnlyTaxCredit = 0;
    this.frameOnlyTaxCreditUsed = false;
    this.exchangeCredit = 0;
    this.returnCredit = 0;
    this.restockingFee = 0;
    this.restockingFeeWaived = false;
    this.redoReason = '';
    this.redoPriority = false;
    this.redoPaidCredit = 0;
    this.fulfillment = 'PICKUP';
    this.shippingAddress = {
      address: '',
      address2: '',
      city: '',
      state: '',
      zip: '',
    };
  }
}

export class LogElement {
  _id: string = null;
  initials?: string = '';
  user?: string = '';
  item?: string = '';
  notes?: string = '';
  date?: string = '';

  constructor() {
    this._id = null;
    this.initials = '';
    this.user = '';
    this.item = '';
    this.notes = '';
    this.date = formatDate(Date.now(), 'MM/dd/yyyy', 'en-US');
  }
}
